<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_exploration_intro')
}

const isOnMapSection = computed(() => {
  return route.path === '/map/galaxy'
})

const goToMap = () => {
  router.push('/map/galaxy')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        Greetings!, I'm your exploration advisor, here to guide you through the vast expanse of our galaxy.
      </p>
      <p class="pb-2">
        Let's begin by familiarizing ourselves with the galaxy map - your window to the universe and the key to successful exploration.
      </p>
      <p>
        Please navigate to the Map section where I'll show you how to explore and control your view of the galaxy.
      </p>
    </template>

    <template #alerts>
      <Alert type="white" class="hidden md:flex">
        Tip: You can minimize or move around this tutorial window if it gets in the way.
      </Alert>
      <Alert type="info" class="hidden md:flex">
        Click on the "Map" button in the top menu.
      </Alert>
      <Alert type="white" class="sm:hidden">
        Tip: You can minimize this tutorial window if it gets in the way.
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "Map".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMapSection" @click="goToMap" class="mr-2">
        Go to Map
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Continue
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>